const root = ((typeof self === 'object') && (self.self === self) && self) || ((typeof global === 'object') && (global.global === global) && global) || this
let reportUnionId

/**
 * Report 基于事件的上报对象
 */
export class Report {
  constructor (eventName, reportObj) {
    this.eventName = eventName
    this.reportObj = reportObj
  }

  report () {
    try {
      if (!reportUnionId) reportUnionId = Report.getNewId()
      if (root.sensors) {
        root.sensors.track(this.eventName, this.reportObj)
      } else {
        console.log(JSON.stringify(this.reportObj))
      }
    } catch (e) {
      console.log(e)
    }
  }

  static getNewId () {
    return Date.now() + (Math.random() * 10000).toFixed()
  }
}
